<div class="error-modal">
  <ng-container *ngFor="let message of messageTranslation$ | async">
    <span class="error-modal__message">{{ message | translate }}</span>
  </ng-container>
  <button class="btn btn-primary error-modal__close-btn" (click)="modal.close()">{{ 'Common.Close' | translate }}</button>
</div>
